import {useState, useEffect} from "react";
import { useAudioPlayerStore } from "../../store/store";
import httpService from "../../services/httpService";
import Button from "react-bootstrap/Button";
import { FaSpinner } from "react-icons/fa6";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import {FaCog, FaPlay, FaRegFile} from "react-icons/fa";
import Collapse from "react-bootstrap/Collapse";
import Card from "react-bootstrap/Card";
import { FaRegTrashAlt } from "react-icons/fa";
import { FaFastForward } from "react-icons/fa";
import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import Tooltip from "react-bootstrap/esm/Tooltip";
import KeyTakeawayImageWithPlaceholder from "../KeyTakeawayImageWithPlaceholder";



const InsightItem = ({onInsightDeleted, insight, onInsightSaved, audioUrl, episode=null }) => {
    const { setAudioUrl, setFrom, seekTo, setFeaturedImage, setPlay, setPause, setEpisodeId } = useAudioPlayerStore();
    const [insightLocal, setInsightLocal] = useState(insight);
    const [saving, setSaving] = useState(false);
    const [canSave, setCanSave] = useState(false);
    const [insightLocalErrors, setInsightLocalErrors] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [openDelete, setOpenDelete] = useState(false);

    useEffect(() => {
        console.log('InsightItem insight:', insight);
    }, []);

    const handleSaveInsight = async (episode) => {
        setSaving(true)
        try {
            const res = await httpService.post("dash/wizard/update-insight",insightLocal);
            if(res.data.status){
                onInsightSaved()
            }
            setCanSave(false)
        } catch (err) {
            setErrorMessage(err.message)
        } finally {
            setSaving(false)
        }
    }

    const handleChange = (e) => {
        if(insight[e.target.name] !== e.target.value){
            setInsightLocal({...insightLocal, [e.target.name] : e.target.value})
            setCanSave(true)
        } else {
            setCanSave(false)
        }
    }
    const handleDeleteInsight = async () => {
        setSaving(true)
        try {
            const res = await httpService.delete("dash/wizard/delete-insight/"+insightLocal.id);
            if(res.data.status){
                onInsightDeleted()
                onInsightSaved()
            }
        } catch (err) {
            setErrorMessage(err.message)
        } finally {
            setSaving(false)
        }
    }

    const hmsToSeconds = (input) => {
        if (input == null) return 0;
        const s = String(input).trim();
        if (s === "") return 0;

        // Plain number (e.g., "90" or "90.5")
        if (/^\d+(\.\d+)?$/.test(s)) return parseFloat(s);

        const parts = s.split(":");
        if (parts.some(p => p === "" || isNaN(p))) return NaN;

        // Right-align to [hh, mm, ss]
        const [hh, mm, ss] = [0, 0, 0].slice(parts.length).concat(parts).map(Number);

        if (mm < 0 || mm >= 60 || ss < 0 || ss >= 60) return NaN;
        if (hh < 0) return NaN;

        return hh * 3600 + mm * 60 + ss; // supports fractional seconds in ss
    }

    const onClickPlay = () => {
        // console.log(episode)
        console.log(audioUrl)
        const seconds = hmsToSeconds(insightLocal.start_time);
        setFrom(insightLocal.title);
        setFeaturedImage(episode?.featured_image);
        setEpisodeId(episode?.pivot?.podcast_episode_id ?? null);
        setAudioUrl(audioUrl);
        seekTo(seconds);
        setPlay()
    }

    return(
        <div className={'component-InsightItem'}>
            <Row>
                <Col sm={12}>
                    <label className="text-muted d-block mb-1">A bespoke image for this insight goes here once the club is live, so listeners have something visual paired with each idea.</label>
                </Col>
                <Col sm={4}>
                    <KeyTakeawayImageWithPlaceholder image={insight?.latest_image ?? null} />
                </Col>
                <Col sm={8} className={'mt-0'}>
                    <Row>
                        <Col sm={12} className={'align-items-center justify-content-end text-end'}>
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>Delete this insight</Tooltip>}
                            >
                                <Button
                                    disabled={openDelete}
                                    onClick={() => setOpenDelete(!openDelete)}
                                    variant="danger"
                                    size={'sm'}
                                    className="text-white"
                                >
                                    <FaRegTrashAlt />
                                </Button>
                            </OverlayTrigger>
                            &nbsp;
                            &nbsp;
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>Update this insight</Tooltip>}
                            >
                                <Button
                                    disabled={!canSave}
                                    onClick={()=>handleSaveInsight()}
                                    variant="outline-secondary"
                                    size={'sm'}
                                >
                                    {saving ? <FaSpinner className={"loading_spinner"} /> : <FaCog />}
                                </Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                    <Row>
                        <Collapse in={openDelete}>
                            <div id="delete-collapse" className="w-100 m-0 p-0">
                                <Card body className="bg-light border-danger my-3 mx-2">
                                    <p className="p-0 m-0">
                                        Are you sure you want to delete <strong>{insight.title}</strong>? <hr/>
                                        <Button
                                            variant="light border-success"
                                            className="ms-3 me-3"
                                            size={'sm'}
                                            onClick={() => setOpenDelete(false)}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            variant="light border-danger"
                                            onClick={handleDeleteInsight}
                                            disabled={saving}
                                            size={'sm'}
                                        >
                                            Confirm Delete
                                        </Button>
                                    </p>
                                </Card>
                            </div>
                        </Collapse>
                    </Row>
                </Col>
                <Col sm={12}>
                    <Form.Group className="" controlId="title">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            name={'title'}
                            value={insightLocal.title}
                            type="text"
                            placeholder="Title"
                            onChange={handleChange}
                            isInvalid={insightLocalErrors.hasOwnProperty('title')}
                            disabled={saving}
                            className={"mb-2"}
                        />
                        <Form.Control.Feedback type="invalid">
                            {insightLocalErrors?.title ?? ""}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="" controlId="insight">
                        <Form.Label>Insight</Form.Label>
                        <Form.Control
                            value={insightLocal.insight}
                            name={'insight'}
                            rows={3}
                            as='textarea'
                            type="text"
                            placeholder="Insight"
                            onChange={handleChange}
                            isInvalid={insightLocalErrors.hasOwnProperty('insight')}
                            disabled={saving}
                            className={"mb-2"}
                        />
                        <Form.Control.Feedback type="invalid">
                            {insightLocalErrors?.description ?? ""}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col sm={12}>
                    <Form.Group className="" controlId="quote">
                        <Form.Label>A line from the episode that captures this idea <span className="text-muted fw-normal">— The exact quote from the transcript that the insight comes from. AI-generated ones can be slightly off, so this is the field worth a quick check.</span></Form.Label>
                        <Form.Control
                            name={'quote'}
                            value={insightLocal.quote}
                            rows={3}
                            as='textarea'
                            type="text"
                            placeholder="A line from the episode that captures this idea"
                            onChange={handleChange}
                            isInvalid={insightLocalErrors.hasOwnProperty('quote')}
                            disabled={saving}
                            className={"mb-2"}
                        />
                        <Form.Control.Feedback type="invalid">
                            {insightLocalErrors?.quote ?? ""}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col sm={12}>
                    <label>The moment in the audio where this insight lives. Listeners can jump straight to it from inside the club, so it's worth being close.</label>
                </Col>
                <Col sm={8}>
                    <Row>
                        <Col sm={6}>
                            <Form.Group className="" controlId="start_time">
                                <Form.Label>Start Time</Form.Label>
                                <Form.Control
                                    value={insightLocal.start_time}
                                    name={'start_time'}
                                    step={1}
                                    type="time"
                                    onChange={handleChange}
                                    isInvalid={insightLocalErrors.hasOwnProperty('start_time')}
                                    disabled={saving}
                                    className={"mb-2"}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {insightLocalErrors?.start_time ?? ""}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group className="" controlId="end_time">
                                <Form.Label>End Time</Form.Label>
                                <Form.Control
                                    value={insightLocal.end_time}
                                    name={'end_time'}
                                    step={1}
                                    type="time"
                                    onChange={handleChange}
                                    isInvalid={insightLocalErrors.hasOwnProperty('end_time')}
                                    disabled={saving}
                                    className={"mb-2"}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {insightLocalErrors?.end_time ?? ""}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                </Col>
                <Col sm={4}>
                    <label className={'mb-2'}>Jump to this moment</label><br/>
                    <Button onClick={() => onClickPlay()} variant="light">
                        <FaPlay />
                    </Button>
                </Col>

                <Col sm={12}>
                    <Form.Group className="" controlId="Implementation">
                        <Form.Label>How to apply this <span className="text-muted fw-normal">— What a listener does with this insight in the week after they hear it. The clearer this is, the more likely they actually try it and tag it.</span></Form.Label>
                        <Form.Control
                            value={insightLocal.implementation}
                            name={'insight'}
                            rows={5}
                            as='textarea'
                            type="text"
                            placeholder="What should the listener try after hearing this?"
                            onChange={handleChange}
                            isInvalid={insightLocalErrors.hasOwnProperty('implementation')}
                            disabled={saving}
                            className={"mb-2"}
                        />
                        <Form.Control.Feedback type="invalid">
                            {insightLocalErrors?.implementation ?? ""}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
        </div>
    )
}

export default InsightItem;